import { call, put, takeLatest, select } from 'redux-saga/effects';
import {
    FETCH_ALL_USERS_REQUEST,
    FETCH_USER_BY_ID_REQUEST,
    fetchAllUsersSuccess,
    fetchAllUsersFailure,
    fetchUserByIdSuccess,
    fetchUserByIdFailure
} from '../actions/user-actions';
import { getAllUsers } from '../../../services/user/user-service';

function* fetchAllUsersSaga(action) {
    try {
        const users = yield call(getAllUsers, action.payload);
        yield put(fetchAllUsersSuccess(users));
    } catch (error) {
        yield put(fetchAllUsersFailure(error.message));
    }
}

function* fetchUserByIdSaga(action) {
    try {
        // Since getUserById doesn't exist in service, we'll find user from the existing users array
        // Note: You should implement getUserById in user-service.js for proper API call
        const state = yield select(state => state.user);
        const user = state.users.find(u => u.id === action.payload);
        if (user) {
            yield put(fetchUserByIdSuccess(user));
        } else {
            yield put(fetchUserByIdFailure('User not found'));
        }
    } catch (error) {
        yield put(fetchUserByIdFailure(error.message));
    }
}

export default function* userSaga() {
    yield takeLatest(FETCH_ALL_USERS_REQUEST, fetchAllUsersSaga);
    yield takeLatest(FETCH_USER_BY_ID_REQUEST, fetchUserByIdSaga);
}
